export default "__VITE_ASSET__372d6c3f__"